import React from "react";
import style from "./About.module.css";
import Stats from "./Stats";
function About() {
  return (
    <>
    <div className="about section" id="about">
    <div className={style.header} >About <span style={{color:"#36f588"}}>me</span></div>
      <div className={style.aboutme} id="about.about.section" >
        <p>Hi, I’m Arth Bhushan</p>
        <p id="user-detail-intro">
        A Full Stack Web Developer, adept at contributing to highly collaborative work environments and finding solutions. Skilled in conceptualizing, developing, and deploying software containing logical and mathematical solutions. 

I am an organised person who believes in continuous learning, improvement and appreciate constructive criticism.

If I could say one of the most interesting things about me, it's the fact that I'm always ready for any challenges that comes to my way in a calm and positive mindset.I have done many projects using HTML, CSS, Javascript, React, Redux, NodeJS, Express, Typescript.
        </p>
        <Stats />
        {/* <li border="1px solid #36f488" bg={"#6a6a6a"} className="nav-link resume" >
       
       <button   className={style.resumeButton  }  border="1px solid #36f488" id="resume-button-1">
       <a href={resume} download="Arth_Bhushan_Resume"  onClick={Handleonclick}  id="resume-link-1">
         <DownloadIcon bg={"#6a6a6a"} />
         Resume </a>
       </button>
    
     </li> */}
      </div>
      </div>
    </>
  );
}

export default About;
